import { render, staticRenderFns } from "./auto-renew-block.vue?vue&type=template&id=712132da&scoped=true&lang=pug&"
import script from "./auto-renew-block.vue?vue&type=script&lang=js&"
export * from "./auto-renew-block.vue?vue&type=script&lang=js&"
import style0 from "./auto-renew-block.vue?vue&type=style&index=0&id=712132da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712132da",
  null
  
)

export default component.exports